module.exports = __webpack_public_path__ + "static/media/HomeScreen_elImage1_1298597997.d4c64265.png";